var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-associations-plot" },
    [
      _vm.loading && !_vm.hasPlotSeriesData && !_vm.hideLoadingStatus
        ? _c("div", { staticClass: "vks-associations-plot-status" }, [
            _vm._v(" Loading associations… "),
          ])
        : _vm.error && !_vm.hasPlotSeriesData
        ? _c(
            "div",
            {
              staticClass: "vks-associations-plot-error",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : !_vm.loading && !_vm.hasPlotSeriesData
        ? _c("div", { staticClass: "vks-associations-plot-status" }, [
            _vm._v(" No association data to plot for this locus. "),
          ])
        : _vm.hasPlotSeriesData
        ? [
            _c(
              "div",
              { ref: "plotStack", staticClass: "vks-associations-plot-stack" },
              [
                _vm.showGwasCeAssociationsSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(0),
                        _vm.loading && !_vm.gwasCePlotRows.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "vks-associations-plot-status vks-associations-plot-status--inline",
                              },
                              [_vm._v(" Loading GWAS-CE associations… ")]
                            )
                          : !_vm.gwasCePlotRows.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "vks-associations-plot-status vks-associations-plot-status--inline vks-associations-plot-status--warning",
                                attrs: { role: "status" },
                              },
                              [_vm._v(" No data found in GWAS-CE ")]
                            )
                          : _c("VariantSifterAssociationRegionPlot", {
                              attrs: {
                                "plot-rows": _vm.gwasCePlotData,
                                "show-legend": true,
                                "recomb-peak-intervals":
                                  _vm.recombPeakIntervals,
                                region: _vm.searchSession?.region,
                                "search-session": _vm.searchSession,
                                "region-zoom": _vm.regionZoom,
                                "region-shift-bp": _vm.regionShiftBp,
                                "region-view-area": _vm.regionViewArea,
                                "view-region": _vm.viewRegion,
                                "plot-overlays-state":
                                  _vm.gwasCePlotOverlaysState,
                                "plot-margin": _vm.plotMargin,
                                "shared-canvas-width": _vm.stackCanvasWidth,
                                "plot-markers": _vm.plotMarkers,
                                utils: _vm.utils,
                              },
                              on: {
                                "update:regionShiftBp": function ($event) {
                                  return _vm.$emit(
                                    "update:regionShiftBp",
                                    $event
                                  )
                                },
                                "update:regionViewArea": function ($event) {
                                  return _vm.$emit(
                                    "update:regionViewArea",
                                    $event
                                  )
                                },
                                "pan-end": function ($event) {
                                  return _vm.$emit("pan-end")
                                },
                                "toggle-position-marker": function ($event) {
                                  return _vm.$emit(
                                    "toggle-position-marker",
                                    $event
                                  )
                                },
                                "toggle-star-variant": function ($event) {
                                  return _vm.$emit(
                                    "toggle-star-variant",
                                    $event
                                  )
                                },
                                "set-reference-variant": function ($event) {
                                  return _vm.$emit(
                                    "set-reference-variant",
                                    $event
                                  )
                                },
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showKpAssociationsSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(1),
                        _vm._l(
                          _vm.searchingPlotSeries,
                          function (series, searchIndex) {
                            return _c(
                              "div",
                              {
                                key: `assoc-search-${
                                  series.phenotype || "primary"
                                }-${series.ancestry}`,
                                staticClass:
                                  "vks-associations-plot-series vks-associations-plot-series--searching",
                              },
                              [
                                series.showPhenotypeHeader
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "vks-associations-phenotype-header",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "vks-associations-phenotype-bubble",
                                            attrs: {
                                              title: `${
                                                series.phenotypeLabel
                                              } · ${series.rows.length.toLocaleString()} associations (searching region)`,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(series.phenotypeLabel) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                series.showAncestryHeader
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "vks-associations-ancestry-header",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "vks-associations-ancestry-bubble",
                                            attrs: {
                                              title: `${
                                                series.label
                                              } · ${series.rows.length.toLocaleString()} associations (searching region)`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "vks-associations-ancestry-bubble-code",
                                              },
                                              [_vm._v(_vm._s(series.ancestry))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "vks-associations-ancestry-bubble-label",
                                              },
                                              [_vm._v(_vm._s(series.label))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "vks-associations-ancestry-bubble-count",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      series.rows.length.toLocaleString()
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !series.rows.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "vks-associations-plot-status vks-associations-plot-status--inline",
                                      },
                                      [
                                        _vm._v(
                                          " No association points for " +
                                            _vm._s(series.label) +
                                            ". "
                                        ),
                                      ]
                                    )
                                  : _c("GP2BrowserAssociationRegionPlot", {
                                      attrs: {
                                        "plot-rows": series.plotData,
                                        "display-height": 24,
                                        "pan-mode": "searching",
                                        "highlight-view-region": _vm.viewRegion,
                                        "show-view-region-handle": true,
                                        "show-view-region-bridge":
                                          searchIndex ===
                                          _vm.searchingPlotSeries.length - 1,
                                        "bridge-genes": _vm.bridgeGenesForPlot,
                                        "viewing-center-bp":
                                          _vm.viewingCenterBp,
                                        "viewing-region-half-width-bp":
                                          _vm.viewingRegionHalfWidthBp,
                                        "show-legend":
                                          series.ancestry ===
                                            _vm.firstPlotSeriesAncestry &&
                                          series.phenotype ===
                                            _vm.firstPlotSeriesPhenotype,
                                        "recomb-peak-intervals":
                                          _vm.searchingRecombPeakIntervals,
                                        region: _vm.searchingRegion,
                                        "search-session": _vm.searchSession,
                                        "region-zoom": 0,
                                        "region-shift-bp": _vm.regionShiftBp,
                                        "region-view-area": 0,
                                        "view-region": _vm.searchingRegion,
                                        "plot-overlays-state":
                                          _vm.plotOverlaysState,
                                        "plot-margin": _vm.plotMargin,
                                        "shared-canvas-width":
                                          _vm.stackCanvasWidth,
                                        "plot-markers": _vm.plotMarkers,
                                        utils: _vm.utils,
                                      },
                                      on: {
                                        "update:regionShiftBp": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "update:regionShiftBp",
                                            $event
                                          )
                                        },
                                        "update:regionViewArea": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "update:regionViewArea",
                                            $event
                                          )
                                        },
                                        "update:viewingCenterBp": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "update:viewingCenterBp",
                                            $event
                                          )
                                        },
                                        "commit-viewing-region": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "commit-viewing-region"
                                          )
                                        },
                                        "pan-end": function ($event) {
                                          return _vm.$emit("pan-end")
                                        },
                                        "toggle-position-marker": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "toggle-position-marker",
                                            $event
                                          )
                                        },
                                        "toggle-star-variant": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "toggle-star-variant",
                                            $event
                                          )
                                        },
                                        "set-reference-variant": function (
                                          $event
                                        ) {
                                          return _vm.$emit(
                                            "set-reference-variant",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                              ],
                              1
                            )
                          }
                        ),
                        _vm._l(_vm.viewingPlotSeries, function (series) {
                          return _c(
                            "div",
                            {
                              key: `assoc-view-${
                                series.phenotype || "primary"
                              }-${series.ancestry}`,
                              staticClass:
                                "vks-associations-plot-series vks-associations-plot-series--viewing",
                            },
                            [
                              series.showPhenotypeHeader
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vks-associations-phenotype-header",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vks-associations-phenotype-bubble",
                                          attrs: {
                                            title: `${
                                              series.phenotypeLabel
                                            } · ${series.rows.length.toLocaleString()} associations in ${
                                              _vm.viewingRegionWidthLabel
                                            } viewing region`,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(series.phenotypeLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              series.showAncestryHeader
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vks-associations-ancestry-header",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vks-associations-ancestry-bubble",
                                          attrs: {
                                            title: `${
                                              series.label
                                            } · ${series.rows.length.toLocaleString()} associations in ${
                                              _vm.viewingRegionWidthLabel
                                            } viewing region`,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vks-associations-ancestry-bubble-code",
                                            },
                                            [_vm._v(_vm._s(series.ancestry))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vks-associations-ancestry-bubble-label",
                                            },
                                            [_vm._v(_vm._s(series.label))]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "vks-associations-ancestry-bubble-count",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    series.rows.length.toLocaleString()
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              !series.rows.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vks-associations-plot-status vks-associations-plot-status--inline",
                                    },
                                    [
                                      _vm._v(
                                        " No association points for " +
                                          _vm._s(series.label) +
                                          " in this " +
                                          _vm._s(_vm.viewingRegionWidthLabel) +
                                          " viewing region. "
                                      ),
                                    ]
                                  )
                                : _c("GP2BrowserAssociationRegionPlot", {
                                    attrs: {
                                      "plot-rows": series.plotData,
                                      "display-height": 120,
                                      "pan-mode": "viewing",
                                      "viewing-center-bp": _vm.viewingCenterBp,
                                      "viewing-region-half-width-bp":
                                        _vm.viewingRegionHalfWidthBp,
                                      "show-legend": false,
                                      "recomb-peak-intervals":
                                        _vm.recombPeakIntervals,
                                      region: _vm.searchingRegion,
                                      "search-session": _vm.searchSession,
                                      "region-zoom": _vm.regionZoom,
                                      "region-shift-bp": _vm.regionShiftBp,
                                      "region-view-area": _vm.regionViewArea,
                                      "view-region": _vm.viewRegion,
                                      "plot-overlays-state":
                                        _vm.plotOverlaysState,
                                      "plot-margin": _vm.plotMargin,
                                      "shared-canvas-width":
                                        _vm.stackCanvasWidth,
                                      "plot-markers": _vm.plotMarkers,
                                      utils: _vm.utils,
                                    },
                                    on: {
                                      "update:regionShiftBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionShiftBp",
                                          $event
                                        )
                                      },
                                      "update:regionViewArea": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionViewArea",
                                          $event
                                        )
                                      },
                                      "update:viewingCenterBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:viewingCenterBp",
                                          $event
                                        )
                                      },
                                      "commit-viewing-region": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "commit-viewing-region"
                                        )
                                      },
                                      "pan-end": function ($event) {
                                        return _vm.$emit("pan-end")
                                      },
                                      "toggle-position-marker": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "toggle-position-marker",
                                          $event
                                        )
                                      },
                                      "toggle-star-variant": function ($event) {
                                        return _vm.$emit(
                                          "toggle-star-variant",
                                          $event
                                        )
                                      },
                                      "set-reference-variant": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "set-reference-variant",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showQtlEvidencesSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(2),
                        _vm.qtlState.loading
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "vks-associations-plot-status vks-associations-plot-status--inline",
                              },
                              [_vm._v(" Loading QTL evidences… ")]
                            )
                          : _vm.qtlState.error
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "vks-associations-plot-status vks-associations-plot-status--inline vks-associations-plot-status--warning",
                                attrs: { role: "status" },
                              },
                              [_vm._v(" " + _vm._s(_vm.qtlState.error) + " ")]
                            )
                          : [
                              !_vm.qtlSearchingPlotRows
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vks-associations-plot-status vks-associations-plot-status--inline",
                                    },
                                    [
                                      _vm._v(
                                        " No QTL evidence for this locus. "
                                      ),
                                    ]
                                  )
                                : _c("GP2BrowserQtlRegionPlot", {
                                    attrs: {
                                      "plot-rows": _vm.qtlSearchingPlotRows,
                                      "display-height": 24,
                                      "pan-mode": "searching",
                                      "highlight-view-region": _vm.viewRegion,
                                      "show-view-region-handle": true,
                                      "show-view-region-bridge": true,
                                      "bridge-genes": _vm.bridgeGenesForPlot,
                                      "viewing-center-bp": _vm.viewingCenterBp,
                                      "viewing-region-half-width-bp":
                                        _vm.viewingRegionHalfWidthBp,
                                      "show-legend": true,
                                      "recomb-peak-intervals":
                                        _vm.searchingRecombPeakIntervals,
                                      region: _vm.searchingRegion,
                                      "region-zoom": 0,
                                      "region-shift-bp": _vm.regionShiftBp,
                                      "region-view-area": 0,
                                      "view-region": _vm.searchingRegion,
                                      "plot-margin": _vm.plotMargin,
                                      "shared-canvas-width":
                                        _vm.stackCanvasWidth,
                                      "plot-markers": _vm.plotMarkers,
                                      utils: _vm.utils,
                                    },
                                    on: {
                                      "update:regionShiftBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionShiftBp",
                                          $event
                                        )
                                      },
                                      "update:regionViewArea": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionViewArea",
                                          $event
                                        )
                                      },
                                      "update:viewingCenterBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:viewingCenterBp",
                                          $event
                                        )
                                      },
                                      "commit-viewing-region": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "commit-viewing-region"
                                        )
                                      },
                                      "pan-end": function ($event) {
                                        return _vm.$emit("pan-end")
                                      },
                                      "toggle-position-marker": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "toggle-position-marker",
                                          $event
                                        )
                                      },
                                      "toggle-star-variant": function ($event) {
                                        return _vm.$emit(
                                          "toggle-qtl-star-variant",
                                          $event
                                        )
                                      },
                                      "set-reference-variant": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "set-reference-variant",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                              !_vm.qtlViewingPlotRows
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "vks-associations-plot-status vks-associations-plot-status--inline",
                                    },
                                    [
                                      _vm._v(
                                        " No QTL evidence in this " +
                                          _vm._s(_vm.viewingRegionWidthLabel) +
                                          " viewing region. "
                                      ),
                                    ]
                                  )
                                : _c("GP2BrowserQtlRegionPlot", {
                                    attrs: {
                                      "plot-rows": _vm.qtlViewingPlotRows,
                                      "display-height": 120,
                                      "pan-mode": "viewing",
                                      "viewing-center-bp": _vm.viewingCenterBp,
                                      "viewing-region-half-width-bp":
                                        _vm.viewingRegionHalfWidthBp,
                                      "show-legend": false,
                                      "recomb-peak-intervals":
                                        _vm.recombPeakIntervals,
                                      region: _vm.searchingRegion,
                                      "region-zoom": _vm.regionZoom,
                                      "region-shift-bp": _vm.regionShiftBp,
                                      "region-view-area": _vm.regionViewArea,
                                      "view-region": _vm.viewRegion,
                                      "plot-margin": _vm.plotMargin,
                                      "shared-canvas-width":
                                        _vm.stackCanvasWidth,
                                      "plot-markers": _vm.plotMarkers,
                                      utils: _vm.utils,
                                    },
                                    on: {
                                      "update:regionShiftBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionShiftBp",
                                          $event
                                        )
                                      },
                                      "update:regionViewArea": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:regionViewArea",
                                          $event
                                        )
                                      },
                                      "update:viewingCenterBp": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "update:viewingCenterBp",
                                          $event
                                        )
                                      },
                                      "commit-viewing-region": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "commit-viewing-region"
                                        )
                                      },
                                      "pan-end": function ($event) {
                                        return _vm.$emit("pan-end")
                                      },
                                      "toggle-position-marker": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "toggle-position-marker",
                                          $event
                                        )
                                      },
                                      "toggle-star-variant": function ($event) {
                                        return _vm.$emit(
                                          "toggle-qtl-star-variant",
                                          $event
                                        )
                                      },
                                      "set-reference-variant": function (
                                        $event
                                      ) {
                                        return _vm.$emit(
                                          "set-reference-variant",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.showCredibleSetsSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(3),
                        _c("VariantSifterCredibleSetsTrack", {
                          attrs: {
                            "selected-sets": _vm.credibleSetsTrackData,
                            "recomb-peak-intervals": _vm.recombPeakIntervals,
                            "color-by-set-id": _vm.credibleSetColors,
                            region: _vm.searchSession?.region,
                            "view-region": _vm.viewRegion,
                            "region-zoom": _vm.regionZoom,
                            "region-shift-bp": _vm.regionShiftBp,
                            "region-view-area": _vm.regionViewArea,
                            "search-session": _vm.searchSession,
                            "shared-canvas-width": _vm.stackCanvasWidth,
                            "plot-markers": _vm.plotMarkers,
                            utils: _vm.utils,
                          },
                          on: {
                            "update:regionShiftBp": function ($event) {
                              return _vm.$emit("update:regionShiftBp", $event)
                            },
                            "update:regionViewArea": function ($event) {
                              return _vm.$emit("update:regionViewArea", $event)
                            },
                            "pan-end": function ($event) {
                              return _vm.$emit("pan-end")
                            },
                            "toggle-position-marker": function ($event) {
                              return _vm.$emit("toggle-position-marker", $event)
                            },
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit("toggle-star-variant", $event)
                            },
                            "set-reference-variant": function ($event) {
                              return _vm.$emit("set-reference-variant", $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showGlobalEnrichmentSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(4),
                        _c("VariantSifterAnnotationsWorkspaceTrack", {
                          attrs: {
                            "global-enrichment-state":
                              _vm.globalEnrichmentState,
                            "workspace-mapping-filter":
                              _vm.workspaceMappingFilter,
                            "search-session": _vm.searchSession,
                            "selected-phenotypes": _vm.selectedPhenotypes,
                            region: _vm.searchSession?.region,
                            "view-region": _vm.viewRegion,
                            "region-zoom": _vm.regionZoom,
                            "region-shift-bp": _vm.regionShiftBp,
                            "region-view-area": _vm.regionViewArea,
                            "shared-canvas-width": _vm.stackCanvasWidth,
                            "plot-markers": _vm.plotMarkers,
                            "recomb-peak-intervals": _vm.recombPeakIntervals,
                            utils: _vm.utils,
                            "tissue-regions-host": _vm.tissueRegionsHost,
                          },
                          on: {
                            "update:regionShiftBp": function ($event) {
                              return _vm.$emit("update:regionShiftBp", $event)
                            },
                            "update:regionViewArea": function ($event) {
                              return _vm.$emit("update:regionViewArea", $event)
                            },
                            "pan-end": function ($event) {
                              return _vm.$emit("pan-end")
                            },
                            "toggle-position-marker": function ($event) {
                              return _vm.$emit("toggle-position-marker", $event)
                            },
                            "update:selectedBiosamples": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedBiosamples",
                                $event
                              )
                            },
                            "update:activeAnnotation": function ($event) {
                              return _vm.$emit(
                                "update:geActiveAnnotation",
                                $event
                              )
                            },
                            "update:selectedTissues": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedTissues",
                                $event
                              )
                            },
                            "update:selectedAnnotations": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedAnnotations",
                                $event
                              )
                            },
                            "select-plot-tissue": function ($event) {
                              return _vm.$emit("select-ge-plot-tissue", $event)
                            },
                            "update:biosampleFilterOptions": function ($event) {
                              return _vm.$emit(
                                "update:geBiosampleFilterOptions",
                                $event
                              )
                            },
                            "update:biosampleTissueRegions": function ($event) {
                              return _vm.$emit(
                                "update:geBiosampleTissueRegions",
                                $event
                              )
                            },
                            "update:biosampleLoading": function ($event) {
                              return _vm.$emit(
                                "update:geBiosampleLoading",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showV2gSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(5),
                        _c("VariantSifterV2gTrack", {
                          attrs: {
                            "v2g-state": _vm.v2gState,
                            "workspace-mapping-filter":
                              _vm.workspaceMappingFilter,
                            region: _vm.searchSession?.region,
                            "view-region": _vm.viewRegion,
                            "region-zoom": _vm.regionZoom,
                            "region-shift-bp": _vm.regionShiftBp,
                            "region-view-area": _vm.regionViewArea,
                            "shared-canvas-width": _vm.stackCanvasWidth,
                            "plot-margin": _vm.plotMargin,
                            "plot-markers": _vm.plotMarkers,
                            "recomb-peak-intervals": _vm.recombPeakIntervals,
                          },
                          on: {
                            "update:regionShiftBp": function ($event) {
                              return _vm.$emit("update:regionShiftBp", $event)
                            },
                            "update:regionViewArea": function ($event) {
                              return _vm.$emit("update:regionViewArea", $event)
                            },
                            "pan-end": function ($event) {
                              return _vm.$emit("pan-end")
                            },
                            "toggle-position-marker": function ($event) {
                              return _vm.$emit("toggle-position-marker", $event)
                            },
                            "update:selectedLinks": function ($event) {
                              return _vm.$emit(
                                "update:v2gSelectedLinks",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showS2gSection
                  ? _c(
                      "div",
                      { staticClass: "vks-plot-section" },
                      [
                        _vm._m(6),
                        _c("VariantSifterV2gTrack", {
                          attrs: {
                            "v2g-state": _vm.s2gState,
                            "workspace-mapping-filter":
                              _vm.workspaceMappingFilter,
                            region: _vm.searchSession?.region,
                            "view-region": _vm.viewRegion,
                            "region-zoom": _vm.regionZoom,
                            "region-shift-bp": _vm.regionShiftBp,
                            "region-view-area": _vm.regionViewArea,
                            "shared-canvas-width": _vm.stackCanvasWidth,
                            "plot-margin": _vm.plotMargin,
                            "plot-markers": _vm.plotMarkers,
                            "recomb-peak-intervals": _vm.recombPeakIntervals,
                            "empty-message":
                              "Load SNP-to-gene links from the SNP 2 gene panel.",
                            "legend-aria-label": "SNP-to-gene methods",
                            "loading-status-template":
                              "Loading SNP-to-gene links…",
                          },
                          on: {
                            "update:regionShiftBp": function ($event) {
                              return _vm.$emit("update:regionShiftBp", $event)
                            },
                            "update:regionViewArea": function ($event) {
                              return _vm.$emit("update:regionViewArea", $event)
                            },
                            "pan-end": function ($event) {
                              return _vm.$emit("pan-end")
                            },
                            "toggle-position-marker": function ($event) {
                              return _vm.$emit("toggle-position-marker", $event)
                            },
                            "update:selectedLinks": function ($event) {
                              return _vm.$emit(
                                "update:s2gSelectedLinks",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm.showGenesSection
              ? _c("div", { staticClass: "vks-genes-track-slot" }, [
                  _vm.genesDockPinned
                    ? _c("div", {
                        staticClass: "vks-genes-track-spacer",
                        style: { height: `${_vm.genesTrackHeight}px` },
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      ref: "genesDock",
                      staticClass: "vks-genes-track-dock",
                      class: { "is-pinned": _vm.genesDockPinned },
                      style: _vm.genesDockPinned
                        ? _vm.genesDockPinnedStyle
                        : null,
                    },
                    [
                      _c("VariantSifterGenesTrack", {
                        key: _vm.genesTrackKey,
                        attrs: {
                          genes: _vm.genesTrackData,
                          "recomb-peak-intervals":
                            _vm.searchingRecombPeakIntervals,
                          region: _vm.searchingRegion,
                          "view-region": _vm.searchingRegion,
                          "plot-margin": _vm.plotMargin,
                          "region-zoom": 0,
                          "shared-canvas-width": _vm.stackCanvasWidth,
                          "plot-markers": _vm.plotMarkers,
                          "color-by-gene-type": _vm.geneTypeColors,
                        },
                        on: { "track-layout": _vm.onGenesTrackLayout },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.ldLoading
              ? _c("p", { staticClass: "vks-associations-plot-note" }, [
                  _vm._v(" Loading LD scores for table… "),
                ])
              : _vm.ldError
              ? _c("p", { staticClass: "vks-associations-plot-note" }, [
                  _vm._v(" " + _vm._s(_vm.ldError) + " "),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v("GWAS-CE associations"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v(" Associations "),
        _c("span", { staticClass: "vks-plot-section-subtitle" }, [
          _vm._v(
            "(search region: downsampled — all p≤0.05 kept, p>0.05 kept with probability (1−p)⁹; viewing region: raw, un-downsampled)"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v(" QTL evidences "),
        _c("span", { staticClass: "vks-plot-section-subtitle" }, [
          _vm._v(
            "(search region: downsampled — all p≤0.05 kept, p>0.05 kept with probability (1−p)⁹; viewing region: raw, un-downsampled)"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v("Credible sets"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v("Global enrichment"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v("Gene links"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "vks-plot-section-head" }, [
      _c("h3", { staticClass: "vks-plot-section-title" }, [
        _vm._v("SNP 2 gene links"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }